import { Pagination } from '..';

export enum NotificationTypes {
  WELCOME = 'WELCOME',
  GENERAL = 'GENERAL',
  FILM = 'FILM',
  UPCOMING_FILM = 'UPCOMING_FILM',
  ORDER_REMINDER = 'ORDER_REMINDER',
  ANNIVERSARY = 'ANNIVERSARY',
  OFFER = 'OFFER',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  SURVEY = 'SURVEY',
  GENERATE_TICKET = 'GENERATE_TICKET',
  EXPIRED_EWALLET_TRANSACTION = 'EXPIRED_EWALLET_TRANSACTION',
  EXPIRED_CASHBACK_WALLET_TRANSACTION = 'EXPIRED_CASHBACK_WALLET_TRANSACTION',
  REFUND_TRANSACTION = 'REFUND_TRANSACTION',
  TOP_UP_TRANSACTION = 'TOP_UP_TRANSACTION',
}

export interface NotificationModel {
  id: string;
  // id: number;
  title: string;
  body: string;
  isRead: boolean;
  type: NotificationTypes | string;
  objectId: string;
  // objectId: number;
  objectUniqueName: string;
  imageUrl: string;
  createdAt: string;
  ownerId: number;
  externalLink: string;
  isPush?: boolean;
  templateNotificationId?: number;
}

export interface PaginatedNotifications {
  data: NotificationModel[];
  pagination: Pagination;
}

export interface PushNotification {
  content: string;
  additionalData: {
    target: null;
    type: NotificationTypes;
    notificationId: string;
    // notificationId: number;
    targetUniqueName?: string;
    templateNotificationId?: number;
  };
  heading: string;
  icon: string;
  id: string;
}
export interface UnreadNotifications {
  count: number;
}
